module.exports = __webpack_public_path__ + "static/media/resume-icon.8fec638f.svg";